import { Numeric9PlusBoxMultipleOutlineIcon } from './Numeric9PlusBoxMultipleOutlineIcon';

/**
 * author: Google
 * id 46A850FC-F6E6-4000-A93F-6B954DA62886
 * name numeric-9-plus-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-plus-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric9PlusBoxesOutlineIcon = Numeric9PlusBoxMultipleOutlineIcon;
export default Numeric9PlusBoxesOutlineIcon